import Layout from '@/layout';

export default {
  weight: 4,
  path: '/goods',
  component: Layout,
  redirect: '/goodsList',
  name: 'goods',
  meta: { title: '商品管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'goodsList',
      name: 'goodsList',
      component: () => import('@/views/goods/goodsList'),
      meta: { title: '商品', icon: 'el-icon-s-data' },
    },
    {
      path: 'goodsDetails',
      name: 'goodsDetails',
      component: () => import('@/views/goods/goodsDetails'),
      meta: { title: '商品详情', icon: 'el-icon-s-data', activeMenu: '/goods/goodsList' },
      hidden: true,
    },
  ],
};
